import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { getFacilityBuildingRoomById, updateFacilityBuildingRoom } from '../../../../services/FacilityBuildingRoomService';

const UpdateFacilityBuildingRoom = () => {
  const [label, setLabel] = useState('');
  const [value, setValue] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRoom = async () => {
      try {
        const room = await getFacilityBuildingRoomById(id);
        setLabel(room.label);
        setValue(room.value);
      } catch (error) {
        console.error('Error fetching facility building room details', error);
      }
    };

    fetchRoom();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateFacilityBuildingRoom(id, { label, value });
      navigate('/settings/fbr/');
    } catch (error) {
      console.error('Error updating facility building room', error);
    }
  };

  return (
    <div>
      <Card>
      <h1>Update Facility Building Room</h1>
      <Form onSubmit={handleSubmit}>
        <Row className='mb-4'>
          <Col>
        <Form.Group controlId="label">
          <Form.Label>Label</Form.Label>
          <Form.Control
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
          />
        </Form.Group>
        </Col>
        <Col>
        <Form.Group controlId="value">
          <Form.Label>Value</Form.Label>
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </Form.Group>
        </Col>
        </Row>
        <Button className='d-flex justify-content-end mb-4' variant="primary" type="submit">
          Update Room
        </Button>
      </Form>
      </Card>

    </div>
  );
};

export default UpdateFacilityBuildingRoom;
